import { ButtonMoreComponent } from './button-more.component';

export default angular
  .module('sfMobile.components.button-more', [
    'sfMobile.services.localization',
    'pascalprecht.translate',
  ])
  .component('sfButtonMore', ButtonMoreComponent).name;
